import React from 'react'
import SalesLandingHeroWithHeader from './sections/SalesLandingHeroWithHeader'
import BusinessTravellerFeaturesSection from './sections/BusinessTravellerFeaturesSection'
import BusinessTravellerStepsSection from './sections/BusinessTravellerStepsSection'
import BusinessTravellerEasyForAllSection from './sections/BusinessTravellerEasyForAllSection'
import BusinessTravellerInActionSection from './sections/BusinessTravellerInActionSection'
import BusinessTravellerReadySection from './sections/BusinessTravellerReadySection'

function BusinessTravellerSalesLandingPage() {
  return <>
    <SalesLandingHeroWithHeader />
    <BusinessTravellerFeaturesSection />
    <BusinessTravellerStepsSection />
    <BusinessTravellerEasyForAllSection />
    <BusinessTravellerInActionSection />
    <BusinessTravellerReadySection />
  </>
}

export default BusinessTravellerSalesLandingPage
